import { render, staticRenderFns } from "./FormCard.vue?vue&type=template&id=638f3f3f&scoped=true"
import script from "./FormCard.vue?vue&type=script&lang=js"
export * from "./FormCard.vue?vue&type=script&lang=js"
import style0 from "./FormCard.vue?vue&type=style&index=0&id=638f3f3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638f3f3f",
  null
  
)

export default component.exports